import React from 'react';
import PayloadDescription from './PayloadDescription';

const Description = () => {
    return (
        <div>
            <p>
                <strong>Potential Payout System</strong> is a helper that
                provides the utility of displaying the potential payout for
                system combinations which is the sum of all valid stakes.
            </p>
            <div>
                The <strong>getPotentialPayoutSystem()</strong> method accepts
                an object ({'{}'}) as parameter. The object keys are:
                <PayloadDescription type="system" />
            </div>
            <div>
                The returned value is in milli format, not formatted, so there
                might be quite a few decimal integers
                <i>(example: 3014099.9999999997)</i> and an additional formatting
                might be needed.
            </div>
            <p>
                Below, there is an example of the input data that is used to
                display the <strong>potential payout system</strong> value.
            </p>
        </div>
    );
};

export default Description;
